import React from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink, Row, Col } from 'reactstrap';
import Config from '../../Core/Config.js';
import {framework} from 'saffroncodejs';
import Axios from 'axios';
import BimeManager from '../../Core/BimeManager';
import UserManager from '../../Core/UserManager';
import {libs,ui} from 'saffroncodejs';
var PageManager = framework.PageManager ;

class HavadesEnferadi extends React.Component {
    constructor(props) {
        super(props);
        var urlParams = PageManager.decodePageParams(props);
        this.currentSodurId = this.encodeSodurId(urlParams[0]);
        this.state = {
            isLoading:true,
            activeTab: 1,
            data:{"CodeMelli":"1219420565","BId":20875,"FullBNo":"93/08/650/2648/9500573","BNSodurDate":"1393/08/18","GId":20,"TNSodurDate":"1390/07/19","BeginDate":"1393/08/17","EndDate":"1394/08/17","BNCodeSodur":"شعبه اصفهان کد 650","Moddat":365,"BNAgentCode":"صبا راد کد 2648","BimeGozar":"نوشين زهري کد 2218594","CustomerMobil":"09132720056","Address":"گلپايگان - خ شهيد مطهري - کوچه يک","CodeMelliOrEconomic":"1219420565","HB":132000,"AfzoodehMaliat":6996,"ShahrdariAvarez":3564,"HBKol":142560,"HBCnt":6000,"CalcType":"سال شمار","PayPeriod":"يكجا","YearHB":6000,"Obligations":[{"Pushesh":" نقص عضو و از كار افتادگي بر اثر حادثه","sarmaye":5000000,"Nerkh":0.16,"ToAge":75,"BSCnt":22},{"Pushesh":"فوت بر اثر حادثه","sarmaye":10000000,"Nerkh":0.16,"ToAge":75,"BSCnt":22},{"Pushesh":"هزينه هاي پزشكي","sarmaye":1200000,"Nerkh":0.3,"ToAge":75,"BSCnt":22},{"Pushesh":"حداکثر سرمايه قابل پرداخت براي مجموع تعهدات بالا","sarmaye":10000000,"Nerkh":0.16,"ToAge":75,"BSCnt":22}],"Zinaf":[{"Id":95114,"BId":20875,"PusheshKind":"فوت بر اثر حادثه","Zinaf":"وراث قانوني","SahmDarsad":100},{"Id":95115,"BId":20875,"PusheshKind":" نقص عضو و از كار افتادگي بر اثر حادثه","Zinaf":"بيمه شده اصلي","SahmDarsad":100},{"Id":95116,"BId":20875,"PusheshKind":"هزينه هاي پزشكي","Zinaf":"بيمه شده اصلي","SahmDarsad":100}],"Conditions":[{"BId":20875,"Sharayet":null}],"Endorsement":[],"Bill":[{"RsdId":37309426,"RsdDate":"1393/08/18","RcvdKind":10,"RcvdkindTitle":"فيش نقدي","TasvieDAmount":142560,"BADisplayName":"ب: بانک ملي  ش: مادر تهران  ح: ‎0106968992002","RcvdNo":"996982","RcvdDate":"1393/08/08","MoneyUnit":1,"BId":20875,"ElhNo":0}],"Reshte":20,"ErrorMessage":null}
        }
        this.state.data = {} ;
        
        this.state.btns=[];
       
       this.loadDetail();
            
    }

    encodeSodurId(encodedId)
    {
        return encodedId;
    }

    componentWillReceiveProps(props)
    {
        var urlParams = PageManager.decodePageParams(props);
        this.currentSodurId = this.encodeSodurId(urlParams[0]);

        this.loadDetail();
    }

    loadDetail()
    {
        Axios.post(BimeManager.reactRedirectDomain,
            
            BimeManager.makeBody("/NovinInsuranceServices/Hds/api/Hds/PolicyInfo",
           
                {id: this.currentSodurId, codeMelli:  UserManager.MelliCode()}
            ),
            BimeManager.header())
            .then((result)=>{
                
                this.setState({data:result.data,isLoading:false})
                console.log("انفرادی حوادث : ",this.state.data);
            })
            .catch((error) => { alert(error) })   
    }
    pagechange(bid,reshte) {
        
        PageManager.changePage(Config.p_pardakhtman,[bid,reshte]);
    }
   
   
    render() {
        return (

            <div>
               <Row>
                    <Col sm="12" className="alignRight  title">
                        <h4>حوادث انفرادی</h4>
                    </Col>
                </Row>
                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={{ active: this.state.activeTab === 1 }}
                            onClick={() => { this.setState({activeTab:1}) }}>
                            جزئیات
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={{ active: this.state.activeTab === 2 }}
                            onClick={() => { this.setState({activeTab:2}) }}>
                            الحاقیه
                        </NavLink>
                    </NavItem>
                    <NavItem>
                    <NavLink
                            className={{ active: this.state.activeTab === 3 }}
                            onClick={() => { this.setState({activeTab:3}) }}>
                           ذینفعان
                        </NavLink>
                        </NavItem>
                    <NavItem>
                        <NavLink onClick={() => {this.pagechange(this.currentSodurId,this.state.data.Reshte)}}>
                            پرداخت شده ها
                        </NavLink>
                    </NavItem>
                    
                </Nav>
               

{ !this.state.isLoading?(
        
         
                <TabContent activeTab={this.state.activeTab}>
                    <TabPane tabId={1}>
                        <Row>
                            <Col sm="12">
                                <div className="container ListOfList">
                                    <Row>
                                        <Col sm="12"><span className="bold-head">کد رایانه بیمه نامه:</span>{this.state.data.BId}</Col>
                                        <Col sm="12"><span className="bold-head">شماره بيمه نامه:</span>{this.state.data.FullBNo}</Col>
                                        <Col sm="12"><span className="bold-head">تاريخ صدور:</span>{this.state.data.BNSodurDate}</Col>
                                        <Col sm="12"><span className="bold-head">واحد صدور:</span>{this.state.data.CodeSodurText}</Col>
                                        <Col sm="12"><span className="bold-head">تاریخ شروع ساعت صفر روز:</span>{this.state.data.BeginDate}</Col>
                                        <Col sm="12"><span className="bold-head">تاریخ پایان ساعت صفر روز:</span>{this.state.data.EndDate}</Col>
                                        <Col sm="12"><span className="bold-head">مدت اعتبار بیمه نامه:</span>{this.state.data.Moddat}</Col>
                                       
                                        <Col sm="12"><span className="bold-head">بیمه گذار:</span>{this.state.data.BimeGozarName}</Col>
                                        <Col sm="12"><span className="bold-head">شغل:</span>{this.state.data.BsJobText}</Col>
                                        <Col sm="12"><span className="bold-head">کدملی:</span>{this.state.data.CodeMelli}</Col>
                                        <Col sm="12"><span className="bold-head">آدرس بیمه گذار:</span>{this.state.data.BGAddress}</Col>
                                        <Col sm="12"><span className="bold-head">تلفن بیمه گذار:</span>{this.state.data.BGTel}</Col>
                                        <Col sm="12"><span className="bold-head">نام و نام خانوادگي بیمه شده:</span>{this.state.data.BimeShodeName}</Col>
                                        <Col sm="12"><span className="bold-head">شماره شناسنامه بیمه شده:</span>{this.state.data.BsIdentityNo}</Col>
                                        <Col sm="12"><span className="bold-head">تاریخ تولد بیمه شده:</span>{this.state.data.BsBirthDate}</Col>
                                        <Col sm="12"><span className="bold-head">شغل بیمه شده:</span>{this.state.data.BsJobText}</Col>
                                        <Col sm="12"><span className="bold-head">محل صدور بیمه شده:</span>{this.state.data.BsSodurPlace}</Col>
                                        <Col sm="12"><span className="bold-head">محل سکونت بیمه شده:</span>{this.state.data.BsAddress}</Col>
                                        <Col sm="12"><span className="bold-head">تلفن بیمه شده:</span>{this.state.data.BsTel}</Col>
                                        <Col sm="12"><span className="bold-head">جمع حق بيمه:</span>{libs.StringFunctions.currancyPrint(this.state.data.KolHb)+('ریال')}</Col>
                                        <Col sm="12"><span className="bold-head">ماليات ارزش افزوده:</span>{libs.StringFunctions.currancyPrint(this.state.data.AfzoodehMaliat)+('ریال')}</Col>
                                        <Col sm="12"><span className="bold-head">عوارض شهرداری:</span>{libs.StringFunctions.currancyPrint(this.state.data.ShahrdariAvarez)+('ریال')}</Col>
                                        <Col sm="12"><span className="bold-head">جمع قابل پرداخت:</span>{libs.StringFunctions.currancyPrint(this.state.data.HbKolMA)+('ریال')}</Col>
                                        <Col sm="12"><span className="bold-head">سرمایه فوت بر اثر حادثه:</span>{libs.StringFunctions.currancyPrint(this.state.data.DieSarmaye)+('ریال')}</Col>
                                        <Col sm="12"><span className="bold-head">حق بیمه فوت بر اثر حادثه:</span>{libs.StringFunctions.currancyPrint(this.state.data.DieHb)+('ریال')}</Col>
                                        <Col sm="12"><span className="bold-head">سرمایه نقص عضو و از كار افتادگي دائم(كلي و جزئي) بر اثر حادثه حداكثر تا مبلغ:</span>{libs.StringFunctions.currancyPrint(this.state.data.NaghsSarmaye)+('ریال')}</Col>
                                        <Col sm="12"><span className="bold-head">حق بیمه نقص عضو و از كار افتادگي دائم(كلي و جزئي) بر اثر حادثه حداكثر تا مبلغ:</span>{libs.StringFunctions.currancyPrint(this.state.data.NaghsHb)+('ریال')}</Col>
                                        <Col sm="12"><span className="bold-head">سرمایه هزينه پزشكي ناشي از حوادث مشمول بيمه حداكثر  مبلغ:</span>{libs.StringFunctions.currancyPrint(this.state.data.PezeshkiSarmaye)+('ریال')}</Col>
                                        <Col sm="12"><span className="bold-head">حق بیمه هزينه پزشكي ناشي از حوادث مشمول بيمه حداكثر  مبلغ:</span>{libs.StringFunctions.currancyPrint(this.state.data.PezeshkiHb)+('ریال')}</Col>
                                        <Col sm="12"><span className="bold-head">سرمایه غرامت  عمومي/بستري در بيمارستان مبلغ:</span>{libs.StringFunctions.currancyPrint(this.state.data.HospitalSarmaye)+('ریال')}</Col>
                                        <Col sm="12"><span className="bold-head">حق بیمه غرامت عمومی بستری در بیمارستان مبلغ:</span>{libs.StringFunctions.currancyPrint(this.state.data.HospitalHb)+('ریال')}</Col>
                                        <Col sm="12"><span className="bold-head">سرمایه غرامت روزانه عمومي مبلغ:</span>{libs.StringFunctions.currancyPrint(this.state.data.DailySarmaye)+('ریال')}</Col>
                                        <Col sm="12"><span className="bold-head">حق بیمه غرامت روزانه عمومي مبلغ:</span>{libs.StringFunctions.currancyPrint(this.state.data.DailyHb)+('ریال')}</Col>
                                        <Col sm="12"><span className="bold-head">شماره فیش:</span>{this.state.data.FishNo}</Col>
                                        <Col sm="12"><span className="bold-head">حق بیمه بیمه نامه:</span>{libs.StringFunctions.currancyPrint(this.state.data.HbKolMA)+('ریال')}</Col>
                                        <Col sm="12"><span className="bold-head">آدرس واحد صدور:</span>{this.state.data.SodurAddressText}</Col>
                                        <Col sm="12"><span className="bold-head">تلفن واحد صدور:</span>{this.state.data.SodurTel}</Col>
                                      
                                        </Row>
                                </div>
                            </Col>
                        </Row>
                    </TabPane>

                    <TabPane tabId={2}>
                        <Row>
                            <Col sm="12">
                                <div className="container ListOfList">
                                    <Row>
                                        {
                                            //alert('bill***'+this.state.data.Bill)
                                          (this.state.data.Endorsement)?  this.state.data.Endorsement.map((endorsement)=>{
                                            return <div className="border-List">
                                                            <Col sm="12"><span className="bold-head">نوع بیمه نامه:</span>{endorsement.BimeKindText}</Col>
                                                            <Col sm="12"><span className="bold-head">کد رایانه بیمه نامه:</span>{endorsement.Bid}</Col>
                                                            <Col sm="12"><span className="bold-head">شماره بیمه نامه:</span>{endorsement.FullBNo}</Col>
                                                            <Col sm="12"><span className="bold-head">تاریخ شروع بیمه نامه:</span>{endorsement.BeginDate}</Col>
                                                            <Col sm="12"><span className="bold-head">تاریخ پایان بیمه نامه:</span>{endorsement.EndDate}</Col>
                                                            <Col sm="12"><span className="bold-head">شماره الحاقیه:</span>{endorsement.ElhNo}</Col>
                                                            <Col sm="12"><span className="bold-head">تاریخ صدور الحاقیه:</span>{endorsement.SodurDate}</Col>
                                                            <Col sm="12"><span className="bold-head">شماره ردیف سالانه:</span>{endorsement.Radif}</Col>
                                                            <Col sm="12"><span className="bold-head">تاریخ اعمال الحاقیه:</span>{endorsement.ActiveDate}</Col>
                                                            <Col sm="12"><span className="bold-head">بیمه گذار:</span>{endorsement.BimeGozarText}</Col>
                                                            
                                                            <Col sm="12"><span className="bold-head">شرح الحاقیه:</span>{endorsement.Sharh}</Col>
                                                            <Col sm="12"><span className="bold-head">حق بیمه اضافی با مالیات:</span>{libs.StringFunctions.currancyPrint(endorsement.EzafiHBWithMaliat)+('ریال')}</Col>
                                                            <Col sm="12"><span className="bold-head">حق بیمه برگشتی با مالیات:</span>{libs.StringFunctions.currancyPrint(endorsement.BargashtiHBWithMaliat)+('ریال')}</Col>
                                                            <Col sm="12"><span className="bold-head">حق بیمه اضافی بدون مالیات:</span>{libs.StringFunctions.currancyPrint(endorsement.EzafiHBwithoutMaliat)+('ریال')}</Col>
                                                            <Col sm="12"><span className="bold-head">حق بیمه برگشتی بدون مالیات:</span>{libs.StringFunctions.currancyPrint(endorsement.BargashtiHBwithoutMaliat)+('ریال')}</Col>
                                                            <Col sm="12"><span className="bold-head">مالیات بر ارزش افزوده:</span>{libs.StringFunctions.currancyPrint(endorsement.VAfzoodehMaliat)+('ریال')}</Col>
                                                            <Col sm="12"><span className="bold-head">عوارض شهرداری:</span>{libs.StringFunctions.currancyPrint(endorsement.VShahrdariAvarez)+('ریال')}</Col>
                                                           <br/>
                                                        </div>
                                                
                                            }):''
                                        }
                                            
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </TabPane>

                        <TabPane tabId={3}>
                            <Row>
                                <Col sm="12">
                                    <div className="container ListOfList">
                                        <Row>
                                            {
                                                //alert('bill***'+this.state.data.Bill)
                                                (this.state.data.Zinaf) ? this.state.data.Zinaf.map((zinafan) => {
                                                    return <div className="border-List">
                                                        <Col sm="12"><span className="bold-head">نام و نام خانوادگی:</span>{zinafan.FullName}</Col>
                                                       
                                                        <Col sm="12"><span className="bold-head">شماره شناسنامه:</span>{zinafan.IdentityNo}</Col>
                                                        <Col sm="12"><span className="bold-head">نسبت:</span>{zinafan.ZinafNesbatText}</Col>
                                                        <Col sm="12"><span className="bold-head">درصد سهم:</span>{zinafan.SahmDarsad}</Col>
                                                        <br />
                                                    </div>

                                                }) : ''
                                            }

                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                        </TabPane>

                        <TabPane tabId={4}>
                            <Row>
                                <Col sm="12">
                                    <div className="container ListOfList">
                                        <Row>
                                            {
                                                //alert('bill***'+this.state.data.Bill)
                                                (this.state.data.Zinaf) ? this.state.data.Zinaf.map((estefadekonandegan) => {
                                                    return <div className="border-List">
                                                        <Col sm="12"><span className="bold-head">پوششهای بیمه ای:</span>{estefadekonandegan.PusheshKind}</Col>
                                                        <Col sm="12"><span className="bold-head">ذینفع:</span>{estefadekonandegan.Zinaf}</Col>
                                                        <Col sm="12"><span className="bold-head">درصد سهم:</span>{estefadekonandegan.SahmDarsad}</Col>
                                                        <br />
                                                    </div>

                                                }) : ''
                                            }

                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                        </TabPane>


                </TabContent>):(<ui.Preloader />)
                
            
            
         }
         </div>
        );
    }
}


export default HavadesEnferadi;


// WEBPACK FOOTER //
// ./src/components/ListCollapse/HavadesEnferadi.js